import React from 'react';
import { Box, Grid } from '@mui/material';
import NewsCard, { NewsFeatureCard, NewsListItem } from '../../components/home/news-card';
import HomeSection, { HomeSectionVariant } from '../../components/home/home-section';
import { useHomeState } from '../context/home-context';
import { useNavigate } from '../../../hooks/useNavigate';

interface SectionNewsProps {
  title?: string;
  subtitle?: string;
  /** Quantidade de notícias exibidas (home customizada); padrão 4. */
  quantity?: number;
  variant?: HomeSectionVariant;
}

const SIDE_LIST_SIZE = 4;

export default function SectionNews({ title, subtitle, quantity = 4, variant = 'plain' }: SectionNewsProps) {
  const { topNews } = useHomeState();
  const navigate = useNavigate();

  if (!topNews || topNews.length === 0) {
    return null;
  }

  // Destaque: a primeira notícia com imagem (ou a primeira, se nenhuma tiver); até 4 em lista compacta ao lado
  // e as demais (home customizada) em grade abaixo
  const visible = topNews.slice(0, quantity);
  const featuredIndex = Math.max(0, visible.findIndex((news) => !!news.urlImageEmphasis));
  const featured = visible[featuredIndex];
  const rest = visible.filter((_, index) => index !== featuredIndex);
  const others = rest.slice(0, SIDE_LIST_SIZE);
  const more = rest.slice(SIDE_LIST_SIZE);

  return (
    <HomeSection
      id="news-section"
      variant={variant}
      title={title || 'Últimas notícias'}
      subtitle={subtitle}
      action={{ label: 'Ver todas as notícias', onClick: () => navigate('/noticias') }}
    >
      <Grid container spacing={{ xs: 3, md: 5 }}>
        <Grid item xs={12} md={others.length > 0 ? 7 : 12}>
          <NewsFeatureCard news={featured} />
        </Grid>
        {others.length > 0 && (
          <Grid item xs={12} md={5}>
            <Box
              component="ul"
              sx={{
                listStyle: 'none',
                '& > li + li': { borderTop: 1, borderColor: 'divider' },
                '& > li:first-of-type > a': { pt: 0 },
              }}
            >
              {others.map((news, index) => (
                <li key={news.id ?? index}>
                  <NewsListItem news={news} />
                </li>
              ))}
            </Box>
          </Grid>
        )}
        {more.map((news, index) => (
          <Grid item xs={12} sm={6} md={3} key={news.id ?? index}>
            <NewsCard news={news} />
          </Grid>
        ))}
      </Grid>
    </HomeSection>
  );
}
